import React from 'react';
import Section from "../../components/general/Section";

export default function DeiTracker() {
  return (
    <Section
      bgColor="bg-white"
      className="min-h-screen"
    >
      <div className="max-w-6xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center">
          DEI Goal Tracker
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto text-center mb-16">
          Coming soon - Track and plan your DEI initiatives
        </p>
      </div>
    </Section>
  );
} 